import React from "react";

import { getFieldParticipationStatus, isFieldEnrolled, useTranslation } from "utils";

import { CarbonProgram, ENROLLMENT_TYPE, PracticeBundle } from "models";

import { Tag } from "components";

type FieldParticipationTagsProps = {
  availablePracticeBundles: PracticeBundle[];
  carbonProgram: CarbonProgram | null | undefined;
  activeFarmReportingYear: number | undefined;
  className?: string;
};

/**
 * A rejected field is never enrolled, so this renders "enrolled", "enrolled" + "reactivated" or "rejected".
 * "enrolled" is hidden for auto-enrollment programs, where every field would carry it.
 * "reactivated" only shows in the reporting year the field was reactivated in.
 */
export const FieldParticipationTags = ({ availablePracticeBundles, carbonProgram, activeFarmReportingYear, className }: FieldParticipationTagsProps) => {
  const { t } = useTranslation(["farm"]);
  const showEnrolled =
    isFieldEnrolled(availablePracticeBundles, carbonProgram ?? null) && carbonProgram?.fieldsManagement?.fieldEnrollmentType !== ENROLLMENT_TYPE.auto;
  const status = getFieldParticipationStatus(availablePracticeBundles, activeFarmReportingYear);

  return (
    <>
      {showEnrolled && <Tag className={className} colour="green-200" text={t("farm:enrolled")} dataTestId="field-participation-enrolled" />}
      {status === "rejected" && <Tag className={className} colour="orange" text={t("farm:rejected")} dataTestId="field-participation-status-rejected" />}
      {status === "reactivated" && (
        <Tag className={className} colour="yellow" text={t("farm:reactivated")} dataTestId="field-participation-status-reactivated" />
      )}
    </>
  );
};
